import PropTypes from "prop-types"
import { map, size } from "lodash"
import { Add, Clear } from "@mui/icons-material"
import { IconButton, Chip, Box } from "@mui/material"
import { formatLabel } from "helpers/securities"
import classNames from "classnames"

const SecuritiesDialogSelector = ({ values, handleDelete, searchSecurities, clearSecurities, disabled }) => {
  const anySelected = !!size(values)

  const handleSearchSecurities = (event) => {
    searchSecurities(event.currentTarget)
  }

  return (
    <Box
      className={classNames("securities-list-universe", { clickable: !anySelected && !disabled })}
      onClick={!anySelected && !disabled ? handleSearchSecurities : undefined}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "100%",
      }}
    >
      <div className="securities-list">
        {size(values)
          ? map(values, (elem, index) => {
              const label = formatLabel(elem)
              return <Chip
                className="filter-security"
                sx={{
                  maxWidth: 140,
                }}
                size="small"
                key={`${label}-${index}`}
                label={label}
                disabled={disabled}
                onDelete={disabled ? undefined : () => handleDelete(elem)}
              />
            })
          : <span onClick={!disabled ? handleSearchSecurities : undefined}>Add securities...</span>}
      </div>
      <Box
        className="securities-list-button-wrapper"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {anySelected && (
          <IconButton
            className="securities-list-button"
            onClick={disabled ? undefined : clearSecurities}
            size="small"
            disabled={disabled}
          >
            <Clear />
          </IconButton>
        )}
        <IconButton
          className="securities-list-button"
          onClick={anySelected && !disabled ? handleSearchSecurities : undefined}
          size="small"
          disabled={disabled}
        >
          <Add />
        </IconButton>
      </Box>
    </Box>
  )
}

SecuritiesDialogSelector.propTypes = {
  values: PropTypes.arrayOf(PropTypes.object),
  searchSecurities: PropTypes.func.isRequired,
  clearSecurities: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default SecuritiesDialogSelector
